import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BarionLog,
  PaymentService,
} from '../../services/payment/payment.service';

@Component({
  selector: 'app-after-payment-redirection',
  templateUrl: './after-payment-redirection.component.html',
  styleUrls: ['./after-payment-redirection.component.scss'],
})
export class AfterPaymentRedirectionComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private paymentService = inject(PaymentService);
  private router = inject(Router);

  paymentId: string;

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe((params) => {
      this.paymentId = params.paymentId;
    });

    const barionLog = await this.paymentService.getBarionLog(this.paymentId);

    await this.navigateAccordingToPaymentStatus(barionLog);
  }

  async navigateAccordingToPaymentStatus(barionLog: BarionLog) {
    if (barionLog.status === 'Succeeded') {
      await this.router.navigate(['payment-success']);
    } else {
      const paymentSiteUrl = await this.paymentService.getPaymentSiteUrl(
        barionLog.clientId,
        barionLog.caseId,
      );
      window.location.assign(paymentSiteUrl);
    }
  }
}
